import { useMutation, useQueryClient } from '@tanstack/react-query';

export default function useUpdateAdminIam() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: { name?: string; email?: string }) => {
      const response = await fetch('/admin/api/iam', {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify(params),
      });
      if (!response.ok) {
        throw new Error('Failed to update admin user');
      }
      return await response.json();
    },
    onSuccess: () => {
      // IAMデータのキャッシュを無効化して、最新のデータを取得
      queryClient.invalidateQueries({ queryKey: ['admin', 'iam'] });
    },
  });
}
